import type { JSX } from 'react';
import { LoginFormContent } from './Content/LoginFormContent';

const Login = (): JSX.Element => <LoginFormContent />;

export { Login };
